"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CheckIcon_1 = __importDefault(require("../common/FirstSection/CheckIcon"));
var styles_1 = require("../common/styles");
var List_1 = __importDefault(require("../common/List"));
var bag1_png_1 = __importDefault(require("./assets/bag1.png"));
var bag2_png_1 = __importDefault(require("./assets/bag2.png"));
var bag3_webp_1 = __importDefault(require("./assets/bag3.webp"));
var bag4_png_1 = __importDefault(require("./assets/bag4.png"));
var bag5_png_1 = __importDefault(require("./assets/bag5.png"));
var bag6_png_1 = __importDefault(require("./assets/bag6.png"));
var bag7_jpg_1 = __importDefault(require("./assets/bag7.jpg"));
var bag8_jpg_1 = __importDefault(require("./assets/bag8.jpg"));
var bag9_jpg_1 = __importDefault(require("./assets/bag9.jpg"));
var bag10_jpg_1 = __importDefault(require("./assets/bag10.jpg"));
var bg_png_1 = __importDefault(require("./FirstSection/bg.png"));
exports.default = {
    bgimageStyle: "\n        max-width: 840px;\n        top: -10px;\n        right: -70px;\n    ",
    FirstSectionBgImage: bg_png_1.default,
    axiosLink: '/api/products/bag?format=json',
    productLink: '/bags/new_v2',
    productNamePlural: 'сумки',
    seoText: (react_1.default.createElement(styles_1.Text, null, "\u0412\u0441\u0435\u0433\u0434\u0430 \u043C\u043E\u0436\u043D\u043E \u043A\u0443\u043F\u0438\u0442\u044C \u0441\u0443\u043C\u043A\u0443 \u0441 \u043F\u0440\u0438\u043D\u0442\u043E\u043C \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435 \u2014 \u043D\u043E \u044D\u0442\u043E \u0431\u0443\u0434\u0435\u0442 \u0441\u0435\u0440\u0438\u0439\u043D\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u043E\u0440\u0438\u0435\u043D\u0442\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043D\u0430 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u044B \u043C\u0430\u0441\u0441. \u0417\u0430\u043A\u0430\u0437 \u043C\u043E\u0434\u0435\u043B\u0438 \u0441 \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u043C \u0434\u0438\u0437\u0430\u0439\u043D\u043E\u043C \u0434\u0430\u0435\u0442 \u043F\u0440\u043E\u0441\u0442\u043E\u0440 \u0432\u0430\u0448\u0435\u043C\u0443 \u0432\u043E\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044E. \u041B\u044E\u0431\u044B\u0435 \u043A\u0440\u0430\u0441\u043A\u0438, \u0442\u0435\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0441\u044E\u0436\u0435\u0442\u044B, \u0430\u0431\u0441\u0442\u0440\u0430\u043A\u0442\u043D\u044B\u0435 \u043F\u0440\u0438\u043D\u0442\u044B, \u043B\u043E\u0433\u043E\u0442\u0438\u043F\u044B \u0441\u043F\u043E\u043D\u0441\u043E\u0440\u043E\u0432 \u2013 \u0442\u0430\u043A\u0430\u044F \u0441\u0443\u043C\u043A\u0430 \u0431\u0443\u0434\u0435\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0443 \u0432\u0430\u0441. \u041C\u043E\u0434\u0435\u043B\u0438\u0440\u0443\u0439\u0442\u0435 \u043E\u0434\u0435\u0436\u0434\u0443 \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E \u0438\u043B\u0438 \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435\u0441\u044C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u0435\u0439 \u043D\u0430\u0448\u0438\u0445 \u0434\u0438\u0437\u0430\u0439\u043D\u0435\u0440\u043E\u0432 \u0434\u043B\u044F \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043C\u0430\u043A\u0435\u0442\u0430 \u043F\u0440\u0438\u043D\u0442\u0430.")),
    firstSectionTitle: (react_1.default.createElement(styles_1.MainTitle, null,
        "\u041F\u0435\u0447\u0430\u0442\u044C \u043D\u0430 \u0441\u0443\u043C\u043A\u0430\u0445",
        react_1.default.createElement("br", null),
        " \u043D\u0430 \u0437\u0430\u043A\u0430\u0437")),
    firstSectionText: (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.Text, null,
            "\u041D\u0430\u043D\u0435\u0441\u0435\u043D\u0438\u0435 \u043B\u043E\u0433\u043E\u0442\u0438\u043F\u043E\u0432 \u0438 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0439 \u043D\u0430 \u0441\u0443\u043C\u043A\u0438 \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 ",
            react_1.default.createElement("br", null),
            "\u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u0435\u0434\u043C\u0435\u0442 \u0433\u0430\u0440\u0434\u0435\u0440\u043E\u0431\u0430, \u043F\u043E\u0434\u0430\u0440\u043E\u043A, ",
            react_1.default.createElement("br", null),
            "\u044D\u043B\u0435\u043C\u0435\u043D\u0442 \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0433\u043E \u0441\u0442\u0438\u043B\u044F. \u0421\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0438 ",
            react_1.default.createElement("br", null),
            "\u043F\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0442 \u043F\u0435\u0440\u0435\u043D\u043E\u0441\u0438\u0442\u044C \u043B\u044E\u0431\u044B\u0435 \u043D\u0430\u0434\u043F\u0438\u0441\u0438 \u0438 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438."),
        react_1.default.createElement(List_1.default, { icon: react_1.default.createElement(CheckIcon_1.default, null) },
            react_1.default.createElement(styles_1.Text, null, "\u041A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u043E\u0434\u0435\u0436\u0434\u0430 \u0438 \u0441\u0443\u0432\u0435\u043D\u0438\u0440\u044B \u043F\u043E\u0434 \u043A\u043B\u044E\u0447"),
            react_1.default.createElement(styles_1.Text, null, "\u041F\u043E\u043C\u043E\u0449\u044C \u0434\u0438\u0437\u0430\u0439\u043D\u0435\u0440\u0430"),
            react_1.default.createElement(styles_1.Text, null, "\u0418\u0437\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0432 \u0434\u0435\u043D\u044C \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F"),
            react_1.default.createElement(styles_1.Text, null, "\u0428\u0438\u0440\u043E\u043A\u0438\u0439 \u0432\u044B\u0431\u043E\u0440 \u0441\u0443\u043C\u043E\u043A")))),
    productsTitle: 'Сумки для нанесения',
    products: [
        {
            link: '/bags/new_v2',
            image: bag1_png_1.default,
            text: 'Холщовая сумка',
        },
        {
            link: '/shopping_bags/new_v2',
            image: bag2_png_1.default,
            text: 'Сумка-шоппер',
        },
        {
            link: '/full_print_bags/new_v2',
            image: bag3_webp_1.default,
            text: 'Сумка с полной запечаткой',
        },
        {
            link: '/full_print_waist_bags/new_v2',
            image: bag4_png_1.default,
            text: 'Поясная сумка 3D',
        },
        {
            link: '/full_print_cosmetic_bags/new_v2',
            image: bag5_png_1.default,
            text: 'Косметичка с полной запечаткой',
        },
        {
            link: '/cardholders/new_v2',
            image: bag6_png_1.default,
            text: 'Картхолдер',
        },
        {
            image: bag7_jpg_1.default,
            text: 'Сумка Carryall',
        },
        {
            image: bag8_jpg_1.default,
            text: 'Сумка Span 3D',
        },
        {
            image: bag9_jpg_1.default,
            text: 'Сумка для покупок Span 70',
        },
        {
            image: bag10_jpg_1.default,
            text: 'Сумка Avoska',
        },
        {},
        {},
    ]
};
